export enum LoadingActions {
  Load = 'LOAD',
  Loaded = 'LOADED',
}

export interface LoadingType {
  loading: boolean;
  count: number;
}

export type LoadingPayloadType = {
  [LoadingActions.Load]: undefined;
  [LoadingActions.Loaded]: undefined;
};
